import React, {useEffect, useState} from 'react';
import {useTranslation} from 'react-i18next';
import ToggleSwitch from '../../../../shared/components/ToggleSwitch';
import {useSelector} from 'react-redux';
import {IAllStates} from '../../../../store/rootReducer';
import {IRegisterPreference} from '../dto/IRegister';
import {StepperButtons} from './StepperButtons';
import {IRegisterStepperProps} from './Step1';
import {ConfirmationModal} from '../../../../shared/components/alert/ConfirmationModal';
import {AuthService} from '../../../service';
import {ErrorToast, SuccessToast} from '../../../../utils/toasters';
import {useHistory} from 'react-router-dom';
import {Col, Form, OverlayTrigger, Tooltip} from 'react-bootstrap';
import {gtmService} from '../../../../utils/gtm.service';
import {FiInfo} from 'react-icons/fi';

export const Step7 = ({stepIdNumber, handleBackStep}: IRegisterStepperProps) => {
    const {t} = useTranslation();
    const history = useHistory();
    const [showConfirmModal, setShowConfirmModal] = useState(false);
    const savedUser = useSelector((state: IAllStates) => state.registration);
    const [notifications, setNotifications] = useState<IRegisterPreference>({
        userId: 0,
        isNotificationByEmailRequested: true,
        isNotificationInBrowserRequested: false,
        isNotificationByMentionRequested: true,
        locale: 'en',
        isUnsubscribed: false,
    });

    const changeHandler = (event: React.ChangeEvent<HTMLInputElement>, name: string) => {
        setNotifications(prev => ({...prev, [name]: name === 'isUnsubscribed' ? !event : event}));
    };

    const handleNextStep = () => {
        AuthService.updateGlobalPreference({
            ...notifications,
            userId: savedUser?.id,
        }).then(response => {
            gtmService('brand_registration');
            history.push('/');
            SuccessToast(t('auth.register.brand.step7.success'));
        }).catch(error => ErrorToast(error));
    };

    useEffect(() => {
        if (savedUser?.id) {
            setNotifications(prevState => (
                    {
                        ...prevState,
                        locale: savedUser.locale,
                        userId: savedUser.id,
                    }
                ),
            );
        }
        // eslint-disable-next-line
    }, [savedUser?.id]);

    return (
        <Form className="w-100" onSubmit={(e) => {
            e.preventDefault();
            handleNextStep();
        }}>

            <div className="row">
                <ConfirmationModal
                    iconUrl="/icons/faq.png"
                    title={'Are you sure you want to proceed?'}
                    description={'If you don\'t enable notifications you could miss out some important updates on your upcoming and already running campaigns.'}
                    action={handleNextStep}
                    show={showConfirmModal} closeModal={() => setShowConfirmModal(false)}
                />
                <div className="col-12">
                    <h5>
                        {t('auth.register.brand.step7.globalPreferences')}
                    </h5>
                    <p className="text-muted">
                        {t('auth.register.brand.step7.globalPreferencesDescription')}
                    </p>
                    <h6 className='text-left'>
                        {t('brand.account.global_preferences_modal.email_notifications')}
                    </h6>
                    <div className="d-flex flex-column w-100">
                        <div className="d-flex justify-content-between align-items-center my-2">
                            <label htmlFor='isNotificationByEmailRequested' className='cursor-pointer'>
                                {t('brand.account.global_preferences_modal.active_campaign_notifications')}
                                <OverlayTrigger placement="top"
                                                overlay={<Tooltip
                                                    id="active_campaign_notifications-tooltip">
                                                    {t('brand.account.global_preferences_modal.active_campaign_notifications_tooltip')}
                                                </Tooltip>}>
                                    <FiInfo size={14} className="cursor-pointer ml-1"/>
                                </OverlayTrigger>
                            </label>
                            <ToggleSwitch
                                onChange={(e: React.ChangeEvent<HTMLInputElement>) => changeHandler(e, 'isNotificationByEmailRequested')}
                                small
                                id="isNotificationByEmailRequested"
                                name="isNotificationByEmailRequested"
                                defaultChecked={notifications?.isNotificationByEmailRequested}
                            />
                        </div>
                        {!notifications?.isNotificationByEmailRequested &&
                            <div className="d-flex justify-content-between align-items-center my-2">
                                <div>
                                    {t('brand.account.global_preferences_modal.mentions_notifications')}
                                    <OverlayTrigger placement="top"
                                                    overlay={<Tooltip
                                                        id="mentions_notifications-tooltip">
                                                        {t('brand.account.global_preferences_modal.mentions_notifications_tooltip')}
                                                    </Tooltip>}>
                                        <FiInfo size={14} className="cursor-pointer ml-1"/>
                                    </OverlayTrigger>
                                </div>
                                <div>
                                    <ToggleSwitch
                                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => changeHandler(e, 'isNotificationByMentionRequested')}
                                        small
                                        id="isNotificationByMentionRequested"
                                        defaultChecked={notifications?.isNotificationByMentionRequested}/>

                                </div>
                            </div>}
                        <div className="d-flex justify-content-between align-items-center my-2">
                            <label htmlFor="isUnsubscribed" className="cursor-pointer">
                                {t('auth.register.brand.step7.marketing_notifications')}
                            </label>
                            <ToggleSwitch
                                onChange={(e: React.ChangeEvent<HTMLInputElement>) => changeHandler(e, 'isUnsubscribed')}
                                small
                                id="isUnsubscribed"
                                defaultChecked={!notifications?.isUnsubscribed}/>
                        </div>
                    </div>
                </div>
                <div className="col-12 mt-4">
                    <StepperButtons currentStep={stepIdNumber - 1} handleNextStep={() => {
                        if ((!notifications.isNotificationByEmailRequested && notifications?.isUnsubscribed)) {
                            setShowConfirmModal(true);
                        } else {
                            handleNextStep();
                        }
                    }}
                                    handleBackStep={handleBackStep}/>
                </div>
            </div>
        </Form>
    );
};
